import { compose as o } from "../../tailwind-buddy-interface.js";
const e = o({
  slots: {
    root: [
      "group/card",
      // Uses in combination with size classes to style related children components
      "overflow-hidden",
      "rounded-lg"
    ]
  },
  variants: {
    /** Sets the elevation level of the card to display content on different types of surfaces. */
    elevation: {
      sunken: "bg-color-elevation-sunken-glass shadow-elevation-sunken",
      flat: "bg-color-elevation-flat-canvas shadow-elevation-flat",
      raised: "bg-color-elevation-raised-canvas shadow-elevation-raised",
      floating: "bg-color-elevation-floating-canvas shadow-elevation-floating"
    },
    /** Sets the card size. It's also affects the size of children components: `CardHeader`, `CardBody`, and `CardFooter`. */
    size: {
      sm: { root: "sm" },
      md: { root: "md" }
    }
  },
  responsiveVariants: [],
  defaultVariants: {
    elevation: "raised",
    size: "md"
  }
})();
export {
  e as cardVariants
};
